import {CUSTOMER_DETAILS_SERVICE_NAME} from "../utils/names/serviceNames";
import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    ActionsServiceModuleName,
    ActionStatusModuleName,
    CampaignsServiceModuleName,
    ContactProfileModuleName,
    CUSTOMER_PROFILE_MODULE_NAME,
    CustomerSubscriptionModuleName,
    LoanArchieModuleName,
    LoggingModuleName,
    NAVIGATABLE_MODULE_NAME,
    NgMessagesModule
} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName, MainServiceModuleName} from "../utils/names/requiredModulesNames";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {CustomerProfileController} from "./route/CustomerProfileController";
import {getTabName} from "modules/utils/TabNameUtils";

function getSelectedCustomerResolver() {
    return [CUSTOMER_DETAILS_SERVICE_NAME, '$route', 'LoaderStatusValue',
        function (CustomerDetailService, $route, LoaderStatusValue) {
            LoaderStatusValue.on();
            return CustomerDetailService.getCustomerDetail($route.current.params.contactId)
                .then(resp => {
                    LoaderStatusValue.off();
                    return resp.data
                });
        }];
}

export const CustomerProfileModuleConfiguration = new RestrictedRouteModuleConfiguration(
    CUSTOMER_PROFILE_MODULE_NAME,
    [
        CustomerSubscriptionModuleName,
        CUSTOMER_PROFILE_MODULE_NAME,
        MainServiceModuleName,
        AngularJsMaterialModuleName,
        NAVIGATABLE_MODULE_NAME,
        LoggingModuleName,
        ActionsServiceModuleName,
        NgMessagesModule,
        CampaignsServiceModuleName,
        ActionStatusModuleName,
        LoanArchieModuleName,
        ContactProfileModuleName
    ],
    [
        ["/contact_profile/:contactId", {
            template: CustomerProfileController.template,
            controller: 'customerProfileController',
            resolve: {
                'selectedCustomer': getSelectedCustomerResolver()
            }
        }]
    ],
    [],
    [CUSTOMER_PROFILE_MODULE_NAME],
    [UserGranredAuthorityName.CUSTOMERS],
    getTabName() + '| Customer Profile'
);

export default CustomerProfileModuleConfiguration;